<template>
  <AdminNavbar>
    <h1 class="font-bold text-lg">Гишүүдийн булан</h1>
    <div class="bg-white rounded shadow">
      <div
        class="flex justify-between items-center border-t-4 border-t-blue-500 rounded-t border-b p-3"
      >
        <!-- <h6 class="text-base">Тайлан</h6> -->
        <router-link
          to="/admin/member-resource"
          class="bg-blue-500 p-2 text-white text-xs rounded hover:bg-blue-600"
        >
          <font-awesome-icon icon="fa-solid fa-list" class="mr-1" />
          Гишүүдийн жагсаалт
        </router-link>
      </div>

      <MMEditMembersResources />
    </div>
  </AdminNavbar>
</template>

<script>
import AdminNavbar from "@/components/admin/AdminNavbar.vue";
import MMEditMembersResources from "@/containers/MiningMongolia/admin/MMEditMembersResources.vue";

export default {
  name: "MMAddMembersResources",
  components: {
    AdminNavbar,
    MMEditMembersResources,
  },
  setup() {
    return {};
  },
};
</script>
